import React, { useContext, useState, useEffect, useRef } from 'react';
import { Grid, Button } from '@mui/material';
import { AppContext } from '../../../context/Context';
import 'react-confirm-alert/src/react-confirm-alert.css';
import '../../../assets/css/buttons.css';
import { useTranslation } from 'react-i18next';
import { SocketContext } from '../../../context/SocketContext';
import toast from 'react-hot-toast';
import {
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
  NextPlan as NextPlanIcon,
} from '@mui/icons-material/';

function SellScreenButtons({
  amount,
  sum,
  action,
  sortDescription,
  executeConfirm,
}) {
  const { t } = useTranslation();
  const { socket } = useContext(SocketContext);

  useEffect(() => {
    if (executeConfirm) {
      confirmButton();
    }
  }, [executeConfirm]);

  const {
    ticketSelectedKioskCH,
    ticketSelectedKioskWG,
    ticketSelectedKioskOK,
    updateTransactionsKiosk,
    updateTransactionsKioskArray,
    updateShowModalSellKiosk,
    isWGEnabled,
    WGBingoID,
    OKBingoID,
    currentTicketOK,
    printer,
    currentTicketWG,
    updateIsSellerOpen,
    isMultiplier,
    updateIsMultiplier,
    updateIsMultiplier2,
    updateIsMultiplier4,
    updateIsMultiplier3,
    updateIsMultiplier5,
    updateIsMultiplier6,
    updateIsMultiplier7,
    updateIsMultiplier8,
    updateIsMultiplier9,
    updateIsMultiplier10,

    operator,
    session,
    hall,
    userInfo,
    parentInfo,
    isTerminalBusy,
    userLimits,
  } = useContext(AppContext);

  const maxAllowed = (() => {
    if (!userLimits?.daily || !userLimits?.monthly) return Infinity;

    const dailyRaw =
      userLimits.daily.limit -
      (userLimits.daily.cashIn - userLimits.daily.cashOut);
    const monthlyRaw =
      userLimits.monthly.limit -
      (userLimits.monthly.cashIn -
        userLimits.monthly.cashOut +
        userLimits.monthly.rollover);

    const dailyAvailable = dailyRaw < 0 ? Infinity : dailyRaw;
    const monthlyAvailable = monthlyRaw < 0 ? Infinity : monthlyRaw;

    return Math.min(dailyAvailable, monthlyAvailable);
  })();

  const ticketSelectedKioskCHRef = useRef(ticketSelectedKioskCH);
  useEffect(() => {
    ticketSelectedKioskCHRef.current = ticketSelectedKioskCH;
  }, [ticketSelectedKioskCH]);

  const ticketSelectedKioskWGRef = useRef(ticketSelectedKioskWG);
  useEffect(() => {
    ticketSelectedKioskWGRef.current = ticketSelectedKioskWG;
  }, [ticketSelectedKioskWG]);

  const ticketSelectedKioskOKRef = useRef(ticketSelectedKioskOK);
  useEffect(() => {
    ticketSelectedKioskOKRef.current = ticketSelectedKioskOK;
  }, [ticketSelectedKioskOK]);

  const isWGEnabledRef = useRef(isWGEnabled);
  useEffect(() => {
    isWGEnabledRef.current = isWGEnabled;
  }, [isWGEnabled]);

  const OKBingoIDRef = useRef(OKBingoID);
  useEffect(() => {
    OKBingoIDRef.current = OKBingoID;
  }, [OKBingoID]);

  const WGBingoIDRef = useRef(WGBingoID);
  useEffect(() => {
    WGBingoIDRef.current = WGBingoID;
  }, [WGBingoID]);

  const [newOKTicket, setNewOKTicket] = useState('');
  const newOKTicketRef = useRef(newOKTicket);
  useEffect(() => {
    newOKTicketRef.current = newOKTicket;
  }, [newOKTicket]);

  const [okTicketID, setOkTicketID] = useState(false);
  const okTicketIDRef = useRef(okTicketID);
  useEffect(() => {
    okTicketIDRef.current = okTicketID;
  }, [okTicketID]);

  const sessionRef = useRef(session);
  useEffect(() => {
    sessionRef.current = session;
  }, [session]);

  const operatorRef = useRef(operator);
  useEffect(() => {
    operatorRef.current = operator;
  }, [operator]);

  const hallRef = useRef(hall);
  useEffect(() => {
    hallRef.current = hall;
  }, [hall]);

  const userInfoRef = useRef(userInfo);
  useEffect(() => {
    userInfoRef.current = userInfo;
  }, [userInfo]);

  const parentInfoRef = useRef(parentInfo);
  useEffect(() => {
    parentInfoRef.current = parentInfo;
  }, [parentInfo]);

  const amountRef = useRef(amount);
  useEffect(() => {
    console.log('Amount updated:', amount);
    amountRef.current = amount;
  }, [amount]);

  const isTerminalBusyRef = useRef(isTerminalBusy);
  useEffect(() => {
    isTerminalBusyRef.current = isTerminalBusy;
  }, [isTerminalBusy]);

  const printerRef = useRef(printer);
  useEffect(() => {
    printerRef.current = printer;
  }, [printer]);

  const isMultiplierRef = useRef(isMultiplier);
  useEffect(() => {
    isMultiplierRef.current = isMultiplier;
  }, [isMultiplier]);

  const currentTicketOKRef = useRef(currentTicketOK);
  useEffect(() => {
    currentTicketOKRef.current = currentTicketOK;
  }, [currentTicketOK]);

  const currentTicketWGRef = useRef(currentTicketWG);
  useEffect(() => {
    currentTicketWGRef.current = currentTicketWG;
  }, [currentTicketWG]);

  const actionRef = useRef(action);
  useEffect(() => {
    actionRef.current = action;
  }, [action]);

  const sortDescriptionRef = useRef(sortDescription);
  useEffect(() => {
    sortDescriptionRef.current = sortDescription;
  }, [sortDescription]);

  useEffect(() => {}, [socket]);

  //* BUTTONS FUNCTION
  const confirmButton = async () => {
    const opacity = await getOpacityAsync();
    if (opacity !== '1') return;

    const multiplier = Math.max(1, parseInt(isMultiplierRef.current) || 1);
    const transactionTemplate = {
      name: actionRef.current + ' - ' + sortDescriptionRef.current,
      amount: parseInt(amountRef.current),
      type: 'transaction',
      description: actionRef.current,
      provider: sortDescriptionRef.current,
    };

    if (
      actionRef.current === 'Fylle på' &&
      sortDescriptionRef.current === 'CH'
    ) {
      transactionTemplate.ticketInfo = ticketSelectedKioskCH;
    }

    if (
      actionRef.current === 'Fylle på' &&
      sortDescriptionRef.current === 'WG'
    ) {
      transactionTemplate.wgID = ticketSelectedKioskWG.wgID;
    }

    if (
      actionRef.current === 'Fylle på' &&
      sortDescriptionRef.current === 'OK D.'
    ) {
      transactionTemplate.okID = ticketSelectedKioskOK.okID;
    }

    if (multiplier === 1) {
      updateTransactionsKiosk(transactionTemplate);
    } else {
      const transactionsToAdd = Array.from({ length: multiplier }, () => ({
        ...transactionTemplate,
      }));
      updateTransactionsKioskArray(transactionsToAdd);
    }

    updateIsMultiplier(1);
    updateIsMultiplier2(false);
    updateIsMultiplier3(false);
    updateIsMultiplier4(false);
    updateIsMultiplier5(false);
    updateIsMultiplier6(false);
    updateIsMultiplier7(false);
    updateIsMultiplier8(false);
    updateIsMultiplier9(false);
    updateIsMultiplier10(false);

    updateShowModalSellKiosk(false);
  };

  const cancelButton = () => {
    if (isTerminalBusy) {
      return;
    }
    updateIsSellerOpen(false);
    updateIsMultiplier(1);
    updateIsMultiplier2(false);
    updateIsMultiplier3(false);
    updateIsMultiplier4(false);
    updateIsMultiplier5(false);
    updateIsMultiplier6(false);
    updateIsMultiplier7(false);
    updateIsMultiplier8(false);
    updateIsMultiplier9(false);
    updateIsMultiplier10(false);

    updateShowModalSellKiosk(false);
  };

  const getOpacityAsync = async () => {
    const multiplier = Math.max(1, parseInt(isMultiplierRef.current) || 1);
    if (parseInt(amountRef.current) * multiplier > maxAllowed) {
      toast.error(
        `${t('kiosk.limitSurpassedTitle')} — ${t('kiosk.limitSurpassedMessage')} (Max: ${maxAllowed} kr)`,
        { style: { fontSize: '24px', padding: '20px 24px' } }
      );
      return '0.25';
    }
    if (parseInt(amount) === 0 || isTerminalBusy) {
      if (
        sortDescriptionRef.current !== 'WG' &&
        sortDescriptionRef.current !== 'OK D.'
      ) {
        return '0.25';
      }
    }
    if (actionRef.current === 'Fylle på' && parseInt(amount) === 0) {
      console.log('case 1');
      return '0.25';
    }

    if (action === 'Ny Billett' && parseInt(amount) > 0) {
      return '1';
    }

    if (
      sortDescriptionRef.current === 'OK D.' &&
      !ticketSelectedKioskOKRef.current
    ) {
      return '0.25';
    }
    if (
      sortDescriptionRef.current === 'WG' &&
      !ticketSelectedKioskWGRef.current
    ) {
      return '0.25';
    }
    if (
      sortDescriptionRef.current === 'CH' &&
      !ticketSelectedKioskCHRef.current
    ) {
      console.log('case 2');
      return '0.25';
    }

    return '1';
  };

  const getOpacity = () => {
    const multiplier = Math.max(1, parseInt(isMultiplier) || 1);
    if (parseInt(amount) * multiplier > maxAllowed) return '0.25';
    if (parseInt(amount) === 0 || isTerminalBusy) {
      if (
        sortDescriptionRef.current !== 'WG' &&
        sortDescriptionRef.current !== 'OK D.'
      ) {
        return '0.25';
      }
    }
    if (actionRef.current === 'Fylle på' && parseInt(amount) === 0) {
      return '0.25';
    }

    if (action === 'Ny Billett' && parseInt(amount) > 0) {
      return '1';
    }

    if (
      sortDescriptionRef.current === 'OK D.' &&
      !ticketSelectedKioskOKRef.current
    ) {
      return '0.25';
    }
    if (
      sortDescriptionRef.current === 'WG' &&
      !ticketSelectedKioskWGRef.current
    ) {
      return '0.25';
    }
    if (
      sortDescriptionRef.current === 'CH' &&
      !ticketSelectedKioskCHRef.current
    ) {
      return '0.25';
    }

    return '1';
  };

  const accent = '#FFC727';
  const glassBorder = '1px solid rgba(255,255,255,0.14)';

  return (
    <Grid
      item
      xs={12}
      sx={{
        width: '100%',
        maxWidth: '100% !important',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Grid
        container
        flexDirection="row"
        sx={{
          width: '100%',
          marginTop: 0,
          marginLeft: 0,
          display: 'flex',
          gap: '14px',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {/*CONFIRM BUTTON*/}
        <Grid item xs sx={{ display: 'flex' }}>
          <Button
            fullWidth
            variant="contained"
            startIcon={<CheckCircleIcon sx={{ fontSize: 32 }} />}
            sx={{
              height: 110,
              borderRadius: '16px',
              bgcolor: accent,
              color: '#000',
              fontWeight: 800,
              fontSize: 22,
              textTransform: 'uppercase',
              opacity: getOpacity(),
              boxShadow: `0 12px 32px ${accent}66`,
              transition: 'transform 0.15s ease, box-shadow 0.15s ease',
              '&:hover': {
                bgcolor: '#FFD54F',
                transform: 'translateY(-2px)',
                boxShadow: `0 16px 40px ${accent}110`,
              },
              '&:active': { transform: 'translateY(0)' },
            }}
            onClick={() => confirmButton()}
          >
            {t('sales.confirm')}
          </Button>
        </Grid>

        {/*CANCEL BUTTON*/}
        <Grid item xs sx={{ display: 'flex' }}>
          <Button
            fullWidth
            variant="contained"
            startIcon={<CancelIcon sx={{ fontSize: 32 }} />}
            sx={{
              height: 110,
              borderRadius: '16px',
              bgcolor: 'rgba(255,255,255,0.08)',
              color: 'rgba(255,255,255,0.75)',
              fontWeight: 800,
              fontSize: 22,
              textTransform: 'uppercase',
              border: glassBorder,
              boxShadow: 'none',
              opacity: isTerminalBusy ? 0.25 : 1,
              transition: 'transform 0.15s ease, background 0.15s ease',
              '&:hover': {
                bgcolor: 'rgba(255,255,255,0.14)',
                transform: 'translateY(-2px)',
                color: 'white',
              },
              '&:active': { transform: 'translateY(0)' },
            }}
            onClick={() => cancelButton()}
          >
            {t('sales.cancel')}
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default SellScreenButtons;
